var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftContractIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.9819 5.625c0.22062 2.3601-1.6426 4.375-3.9819 4.375-1.0712 0-2.044-0.42443-2.7625-1.1125l1.1224-1.1223c0.2362-0.23622 0.06889-0.64017-0.2652-0.64017h-3.3447c-0.2071 0-0.375 0.1679-0.375 0.375v3.3447c0 0.3341 0.40392 0.5014 0.64013 0.2651l1.073-1.073c1.0129 0.9824 2.3927 1.5882 3.9119 1.5882 3.2225 0 5.8276-2.7269 5.6111-6h-1.6292zm1.003-4.7348-1.073 1.073c-1.0129-0.98238-2.3926-1.5882-3.9119-1.5882-3.2225 0-5.8276 2.7269-5.6111 6h1.6292c-0.22065-2.3601 1.6426-4.375 3.9819-4.375 1.0712 0 2.044 0.42443 2.7625 1.1125l-1.1224 1.1223c-0.2362 0.23625-0.0689 0.64017 0.26519 0.64017h3.3447c0.2072 0 0.375-0.1679 0.375-0.375v-3.3447c0-0.33407-0.4039-0.5014-0.6401-0.26514z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftContractIcon);
export default __webpack_public_path__ + "static/media/draftContractIcon.68bb2d90964796eaaef2547ddfd681e5.svg";
export { ForwardRef as ReactComponent };